export const REQUEST_GUEST_GROUP = 'zola/collectAddress/REQUEST_GUEST_GROUP';
export const CREATE_GUEST_GROUP = 'zola/collectAddress/CREATE_GUEST_GROUP';
export const UPDATE_GUEST_GROUP = 'zola/collectAddress/UPDATE_GUEST_GROUP';
export const RECEIVE_GUEST_GROUP = 'zola/collectAddress/RECEIVE_GUEST_GROUP';



// WEBPACK FOOTER //
// ./src/actions/types/CollectAddressActionTypes.js